<template>
  <div class="card card-body index p-0">
    <div class="d-flex">
      <div class="ml-auto p-2">
        <button @click.prevent="handleAdd" class="btn btn-primary">
          Přidat webinar
        </button>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Název</th>
          <th>SE List ID</th>
          <th>Webinar ID</th>
          <th>Počet registrovaných</th>
          <th>Akce</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="webinar in webinars" :key="webinar.id">
          <td>{{ webinar.name }}</td>
          <td>{{ webinar.se_list_id }}</td>
          <td>{{ webinar.webinar_id }}</td>
          <td>
            <a href="#" @click.prevent="handleShowRegistrants(webinar)" v-if="webinar.registrants_count > 0">
              {{ webinar.registrants_count }}
            </a>
            <span v-else>0</span>
          </td>
          <td>
            <a href="#" @click.prevent="handleEdit(webinar)">edit</a>
            |
            <a href="#" @click.prevent="handleDelete(webinar)">smazat</a>
          </td>
        </tr>
      </tbody>
    </table>

    <modal-form 
      :webinar="currentWebinar" 
      ref="modalForm" 
      @webinarUpdated="loadWebinars"
    ></modal-form>

    <registrants-modal 
      ref="registrantsModal"
    ></registrants-modal>
  </div>
</template>

<script>
import axios from "axios";
import ModalForm from "./modal-form.vue";
import RegistrantsModal from "./registrants-modal.vue";

export default {
  name: "ever-webinars-index",
  components: { ModalForm, RegistrantsModal },
  data() {
    return {
      webinars: [],
      currentWebinar: {}
    };
  },
  async created() {
    await this.loadWebinars();
  },
  methods: {
    async loadWebinars() {
      const response = await axios.get('/ever_webinars.json');
      this.webinars = response.data.ever_webinars;
    },
    handleAdd() {
      this.currentWebinar = { name: '', se_list_id: null, webinar_id: null };
      this.$refs.modalForm.showModal();
    },
    handleEdit(webinar) {
      this.currentWebinar = Object.assign({}, webinar);
      this.$refs.modalForm.showModal();
    },
    async handleDelete(webinar) {
      if (confirm(`Opravdu smazat ${webinar.name}?`)) {
        await axios.delete(`/ever_webinars/${webinar.id}.json`);
        this.loadWebinars();
      }
    },
    handleShowRegistrants(webinar) {
      this.$refs.registrantsModal.showModal(webinar.id, webinar.name);
    }
  }
};
</script>

<style scoped>
</style>
